import { render, staticRenderFns } from "./legacy_salary_Data.vue?vue&type=template&id=1c12f14c&scoped=true"
import script from "./legacy_salary_Data.vue?vue&type=script&lang=js"
export * from "./legacy_salary_Data.vue?vue&type=script&lang=js"
import style0 from "./legacy_salary_Data.vue?vue&type=style&index=0&id=1c12f14c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c12f14c",
  null
  
)

export default component.exports